module.exports = __webpack_public_path__ + "static/media/Lanai.5b302b93.jpg";